export const tr = {
    budget: 'Bütçe, {currency}',
    clicks: 'Tıklamalar',
    'clicks-forecast': 'Tıklama tahmini',
    cost: 'Harcama, {currency}',
    'cost-forecast': 'Harcama tahmini, {currency}',
    name: 'Kampanya adı',
    'recommended-budget': 'Önerilen bütçe, {currency}',
    status: 'Durum',
    type: 'Tür'
};
